import { useMemo } from 'react';

import { compose, getDimension, getElement, getProperty, sum } from './utils/warning.helpers';
import type { TWarningLogicResult } from './warning.types';

/** Calcula o marginTop dinâmico do aviso com base na altura do elemento de mensagem no DOM. */
export const useWarningLogic = (): TWarningLogicResult => {
	const marginTop = useMemo(
		() =>
			(compose(sum(15), getProperty('height'), getDimension, getElement)('.proposals__items__content--message') as number) || 0,
		[]
	);

	return { marginTop };
};
